module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/solution2_1-440d734ee1bf284c792048faa34b3a6b.png";